<template>
    <el-button @click="opederive()">导出</el-button>
</template>
<script>
import { Select,Button} from 'element-ui'
import api from '../../../com/ajax' // ajax请求封装
import config from '../../../com/config' //url配置文件

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            parm:'',
            name:'',
            url:''
        }
    },
    props:{
        
    },
    watch:{
        
    },
    methods:{
        //获取url参数
        getUrlParam: function(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
            var r = decodeURI(window.location.search.substr(1)).match(reg); //匹配目标参数
            if(r != null) return unescape(r[2]);
            return null; //返回参数值
        },
        downloadXls(url, pojo, filename) {//封装好的导出函数
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.responseType = 'arraybuffer';
            xhr.onload = function() {
                if(this.status === 200) {
                    var type = xhr.getResponseHeader('Content-Type');
                    var blob = new Blob([this.response], {
                        type: type
                    });
                    if(typeof window.navigator.msSaveBlob !== 'undefined') {
                        filename += '.xls';
                        window.navigator.msSaveBlob(blob, filename);
                    } else {
                        var URL = window.URL || window.webkitURL;
                        var downloadUrl = URL.createObjectURL(blob);
                        if(filename) {
                            // use HTML5 a[download] attribute to specify filename
                            var a = document.createElement("a");
                            // safari doesn't support this yet
                            if(typeof a.download === 'undefined') {
                                window.location = downloadUrl;
                            } else {
                                a.href = downloadUrl;
                                a.download = filename + '.xls';
                                document.body.appendChild(a);
                                a.click();
                            }
                        } else {
                            window.location = downloadUrl;
                        }
                        setTimeout(function() {
                                URL.revokeObjectURL(downloadUrl);
                            },
                            100); // cleanup
                    }
                }
            };
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.setRequestHeader('Haiziguo-Token', localStorage.getItem('Haiziguo-Token'));
            xhr.send(pojo);
        },
        opederive(){//导出按钮
            //this.parm是当前页面的查询条件
            //this.name就是buildReport.do中传入的参数frequentlyEncounteredDiseaseConstructor
            //condition:{reportID:"frequentlyEncounteredDiseaseConstructor"}//查询条件中的参数
            //operation:{elements: [{id: "export", name: "导出", url: "/hhs/statistics/export.do"}]}
            //params:{cityID: "", countryID: "", orgID: "", yearName: "2017"}
            this.downloadXls(config.host+'statistics/export.do', JSON.stringify({params:{cityID: "", countryID: "", orgID: "", yearName: "2017"},reportID:"frequentlyEncounteredDiseaseConstructor"}), this.name)
            
        }
    },
    created:function(){
        var self = this;
        // var reportID=rptbl.getUrlParam('rpid') || 'staffMECStatisticalQueryImpl'
        api.post(config.host+'statistics/buildReport.do', { 'reportID': "frequentlyEncounteredDiseaseConstructor"}).then((data) => {
                
                if(data.success == true){

                   this.name=data.body.table.data.name;
                   this.parm=data.body.condition.params;
                   for(var i=0;i<data.body.operation.elements.length;i++){
                    this.url=data.body.operation.elements[i].url;
                    console.log(this.url)
                   }
                }
                

        })

    }
}
</script>

<style>
/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>



// WEBPACK FOOTER //
// src/components/reports/codeCom/export.vue?c6736434